// pkce.js
export function generateRandomString(length) {
  const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  let result = "";
  const randomValues = new Uint8Array(length);
  window.crypto.getRandomValues(randomValues);
  randomValues.forEach(v => result += charset[v % charset.length]);
  return result;
}

export async function sha256(buffer) {
  const digest = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(buffer));
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .split("=")[0];
}

export async function createPKCECodes() {
  const code_verifier = generateRandomString(64);
  const code_challenge = await sha256(code_verifier);
  return { code_verifier, code_challenge };
}
